import { RouterModule } from '@angular/router';
import { RadioButtonComponent } from './atomic/atoms/radio-button/radio-button.component';
import { CustomMaterialModule } from '../core/material.module';
import { SimpleTileSubtitleComponent } from './atomic/organisms/sections/simple-tile-subtitle/simple-tile-subtitle.component';
import { SimpleTileTitleComponent } from './atomic/organisms/sections/simple-tile-title/simple-tile-title.component';
import { SimpleTileActionComponent } from './atomic/organisms/sections/simple-tile-action/simple-tile-action.component';
import { CardBodyComponent } from './atomic/organisms/sections/card-body/card-body.component';
import { CardHeaderComponent } from './atomic/organisms/sections/card-header/card-header.component';
import { MjNotificationMarkerComponent } from './components/mj-notification-marker/mj-notification-marker.component';
import { AutosizeDirective } from './autosizeDirective/autosize.directive';
import { AlertComponent } from './components/alert/alert.component';
import { MjCardComponent } from './components/mj-card/mj-card.component';
import { MjCardBodyComponent } from './components/mj-card-body/mj-card-body.component';
import { MjCardFooterComponent } from './components/mj-card-footer/mj-card-footer.component';
import { MjCardHeaderComponent } from './components/mj-card-header/mj-card-header.component';
import { MjColorPickerComponent } from './components/mj-color-picker/mj-color-picker.component';
import { MjDatePickerComponent } from './components/mj-date-picker/mj-date-picker.component';
import { MjDatePickerControlsComponent } from './components/mj-date-picker-controls/mj-date-picker-controls.component';
import { MjDateVisualiserComponent } from './components/mj-date-visualiser/mj-date-visualiser.component';
import { MjImageDragDropComponent } from './components/mj-image-drag-drop/mj-image-drag-drop.component';
import { MjUnsplashGalleryComponent } from './components/mj-unsplash-gallery/mj-unsplash-gallery.component';
import { MjTextEditorComponent } from './components/mj-text-editor/mj-text-editor.component';
import { MjTextInputComponent } from './components/mj-text-input/mj-text-input.component';
import { MjTextareaComponent } from './components/mj-textarea/mj-textarea.component';
import { MojobTextFieldComponent } from './components/mojobTextField/mojobTextField.component';
import { NgModule } from '@angular/core';
import { MojobTextViewComponent } from './components/mojobTextView/mojobTextView.component';
import { CommonModule } from '@angular/common';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxUploaderModule } from 'ngx-uploader';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import {
  FormGroupDirective,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { AutosizeModule } from 'ngx-autosize';
import { MapToIterablePipe } from './pipes/mapToIterable';
import { OrderApplicantsByPipe } from './pipes/orderApplicantsPipe';
import { OrderByPipe } from './pipes/orderByPipe';
import { SearchPipe } from './pipes/search.pipe';
import { FilterStatusPipe } from './pipes/statusFilter.pipe';
import { TruncatePipe } from './pipes/truncatePipe';
import { NiceSelectComponent } from './components/niceSelect/niceSelect.component';
import { ImagePopupComponent } from './components/imagePopup/imagePopup.component';
import { DropdownFilterComponent } from './components/dropdownfilter/dropdownfilter.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { GoogleplaceDirective } from '../lib/directives/googlePlace';
import { OreToCrownPipe } from './pipes/oreToCrown.pipe';
import { Utils } from '../lib/services';
import { DatePipeProxy } from './pipes/datePipe';
import { LottieWrapperComponent } from './components/lottie-wrapper/lottie-wrapper.component';
import { ProfilePictureComponent } from '../users-module/components/profile-picture/profile-picture.component';
import { TileGridComponent } from './atomic/organisms/sections/tile-grid-component/tile-grid.component';
import { TileComponent } from './atomic/molecules/blocks/tile-component/tile.component';
import { CardComponent } from './atomic/organisms/sections/card/card.component';
import { SimpleTileComponent } from './atomic/molecules/blocks/simple-tile-component/simple-tile.component';
import { CardFooterComponent } from './atomic/organisms/sections/card-footer/card-footer.component';
import { ButtonComponent } from './atomic/atoms/button/button.component';
import { FilterJobByType } from './pipes/filterJobByTypePipe';
import { StepTypePipe } from '../jobs-module/edit-job-tpl-process/children/step-type-pipe';
import { DropdownComponent } from './atomic/atoms/dropdown/dropdown.component';
import { SearchComponent } from './atomic/atoms/search/search.component';
import { AutocompleteComponent } from './atomic/atoms/autocomplete/autocomplete.component';
import { OrderJobByUpdatedAtPipe } from './pipes/orderJobByUpdatedAtPipe';
import { ConfirmationDialogComponent } from './components/mj-confirmation-dialog/confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';

const COMPONENTS = [
  // components
  AlertComponent,
  MjCardComponent,
  MjCardBodyComponent,
  MjCardFooterComponent,
  MjCardHeaderComponent,
  MjColorPickerComponent,
  MjDatePickerComponent,
  MjDatePickerControlsComponent,
  MjDateVisualiserComponent,
  MjImageDragDropComponent,
  MjUnsplashGalleryComponent,
  MjTextEditorComponent,
  MjTextInputComponent,
  MjTextareaComponent,
  MojobTextFieldComponent,
  MojobTextViewComponent,
  NiceSelectComponent,
  ImagePopupComponent,
  DropdownFilterComponent,
  LottieWrapperComponent,
  ProfilePictureComponent,

  // pipes
  MapToIterablePipe,
  OrderApplicantsByPipe,
  OrderByPipe,
  SearchPipe,
  FilterStatusPipe,
  TruncatePipe,
  GoogleplaceDirective,
  OreToCrownPipe,
  OrderJobByUpdatedAtPipe,
  DatePipeProxy,
  FilterJobByType,
  AutosizeDirective,
  MjNotificationMarkerComponent,
  StepTypePipe,

  // ATOMIC
  TileGridComponent,
  TileComponent,
  SimpleTileComponent,
  CardComponent,
  CardHeaderComponent,
  CardBodyComponent,
  CardFooterComponent,
  ButtonComponent,
  SimpleTileTitleComponent,
  SimpleTileSubtitleComponent,
  SimpleTileActionComponent,
  RadioButtonComponent,
  DropdownComponent,
  SearchComponent,
  AutocompleteComponent,
  ConfirmationDialogComponent,
];

@NgModule({
  declarations: [COMPONENTS],
  exports: [COMPONENTS],
  imports: [
    CommonModule,
    ColorPickerModule,
    NgxUploaderModule,
    CustomMaterialModule,
    TranslateModule,
    FormsModule,
    QuillModule,
    MatSelectModule,
    ReactiveFormsModule,
    AutosizeModule,
    FlexLayoutModule,
    RouterModule,
    MatDialogModule,
  ],
  entryComponents: [MjUnsplashGalleryComponent, ConfirmationDialogComponent],
  providers: [FormGroupDirective, Utils],
})
export class SharedModule {}
